<template>
  <div class="nw-options">
    <!-- @slot slot to render options text -->
    <div v-if="hasSFNOptions" class="dropdown-header">
      ShipBob Fulfillment Network
    </div>
    <slot
      v-for="option in getSFNOptions"
      :option="option"
    />
    <div class="dropdown-header">
      Merchant Fulfillment Network
    </div>
    <slot
      v-for="option in getMerchantOptions"
      :option="option"
    />
  </div>
</template>

<script>

export default {
  name: 'NwOptions',
  inject: {
    SbSelect: {}
  },
  computed: {
    hasOptionDefaultSlot () {
      return this.$slots.default && this.$slots.default()
    },
    options () {
      return this.SbSelect.options
    },
    getSFNOptions () {
      if (this.SbSelect.options.length) {
        return this.SbSelect.options.filter(option => option.pricingGroupId === 1)
      }
      return []
    },
    hasSFNOptions () {
      return this.SbSelect.options.length && this.SbSelect.options.filter(option => option.pricingGroupId === 1).length
    },
    getMerchantOptions () {
      if (this.SbSelect.options.length) {
        return this.SbSelect.options.filter(option => option.pricingGroupId === 2)
      }
      return []
    }
  }
}
</script>

<style scoped lang='scss'>
@import "./style/nw-options";

.dropdown-header {
  font-family: proxima-nova;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #3D444F;
  padding: 14px 18px 6px 18px;
}

</style>
